"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailValuePrice = exports.DetailValue = exports.DetailKey = exports.Detail = exports.SectionContents = exports.SectionHeading = exports.Section = exports.SectionPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SectionPanel = function (_a) {
    var className = _a.className, id = _a.id, key = _a.key, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { id: "".concat(id || ""), className: "section-panel ".concat(className || ""), children: children }, "".concat(key || "")));
};
exports.SectionPanel = SectionPanel;
var Section = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "section ".concat(className || ""), children: children }));
};
exports.Section = Section;
var SectionHeading = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "section-heading text-blue-green font-weight-semi-bold ".concat(className || ""), children: children }));
};
exports.SectionHeading = SectionHeading;
var SectionContents = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "section-contents ".concat(className || ""), children: children }));
};
exports.SectionContents = SectionContents;
var Detail = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail ".concat(className || ""), children: children }));
};
exports.Detail = Detail;
var DetailKey = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-key ".concat(className || ""), children: children }));
};
exports.DetailKey = DetailKey;
var DetailValue = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-value ".concat(className || ""), children: children }));
};
exports.DetailValue = DetailValue;
var DetailValuePrice = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-value font-weight-semi-bold text-blue-1", children: children }));
};
exports.DetailValuePrice = DetailValuePrice;
//# sourceMappingURL=SectionPanelTags.js.map